var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWallet = function SvgWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 46 46"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.284 8.907a3.96 3.96 0 0 1 3.953-3.953h1.369l-.413-1.148a1.58 1.58 0 0 0-2.029-.95L8.34 7.887a1.58 1.58 0 0 0-.944 2.03l.73 1.994h11.158z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.236 7.325a1.58 1.58 0 0 0-1.58 1.582v3.004H35.49V8.907c0-.874-.708-1.582-1.581-1.582zM39.682 34.72h-5.534c-3.27 0-5.93-2.66-5.93-5.93a5.936 5.936 0 0 1 5.93-5.929h5.534v-5.416a3.163 3.163 0 0 0-3.163-3.162H5.922a3.163 3.163 0 0 0-3.162 3.162v22.633a3.163 3.163 0 0 0 3.162 3.162H36.52a3.163 3.163 0 0 0 3.162-3.163z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M42.054 25.233h-7.906a3.56 3.56 0 0 0-3.558 3.558 3.56 3.56 0 0 0 3.558 3.558h7.906c.654 0 1.186-.532 1.186-1.186v-4.744c0-.654-.532-1.186-1.186-1.186m-7.906 4.744a1.186 1.186 0 1 1 0-2.372 1.186 1.186 0 0 1 0 2.372"
  })));
};
export default SvgWallet;